// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3nbej","row":"Node_row__199sv","label":"Node_label__QFeRH","footer":"Node_footer__A5bJQ"};